import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import { IRootState } from "src/store/reducers";
import { TabProps } from "src/views/ApplicationBuilder/pages";
import * as S from "../constants/StringConstants";

const useAutosave = (props: TabProps, performSave: (newAppId: any) => void) => {
  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const { shouldSave, newAppId } = useSelector((state: IRootState) => state.applicationBuilder);
  const { dirty, onDirty, onValid, onChangeURL, changeToURL, isReadonly } = props;

  useEffect(() => {
    onDirty(false);
    onValid(true, []);
  }, []);

  useEffect(() => {
    if (!changeToURL) {
      return;
    }
    if (dirty && !isReadonly && !saving) {
      setIsModalOpen(true);
      return;
    }
    onChangeURL();
    history.push(changeToURL);
  }, [changeToURL, performSave, history, onChangeURL]);

  useEffect(() => {
    if (shouldSave && !isReadonly) {
      performSave(newAppId);
    }
  }, [shouldSave]);

  const handleSave = async () => {
    setSaving(true);
    await performSave(null);
    setIsModalOpen(false);
    onChangeURL();
    history.push(changeToURL);
  };

  const handleDiscard = () => {
    setIsModalOpen(false);
    onChangeURL();
    history.push(changeToURL);
  };

  const handleReject = () => {
    onChangeURL();
    setIsModalOpen(false);
  };

  const Component = _props => (
    <PromptModal
      open={isModalOpen}
      title={S.APP_BUILDER_AUTOSAVE_TITLE}
      confirmText={S.APP_BUILDER_AUTOSAVE_DISCARD}
      confirmText2={S.APP_BUILDER_AUTOSAVE_CONFIRM}
      rejectText={S.APP_BUILDER_AUTOSAVE_REJECT}
      onConfirm={handleDiscard}
      onConfirm2={handleSave}
      onReject={handleReject}>
      <Typography variant="h6">{S.APP_BUILDER_AUTOSAVE_MESSAGE}</Typography>
    </PromptModal>
  );

  return Component;
};

export default useAutosave;
